import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './directAscent.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { DirectAscent } from "model/dealer/directAscent.model";

export interface DirectAscentDetailsProps extends DetailsStateAndDispatchProps<DirectAscent,'activityType'>,
  RouteComponentProps, StateProps, DispatchProps {
}
const DirectAscentDetails: FC<DirectAscentDetailsProps> = (props) => {
  return (
    <DetailsPage<DirectAscent,'activityType'>
      title={'详情'}
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<DirectAscent>
        columns={props.columns as any}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>

    </DetailsPage>);
};

const mapStateToProps = ({ directAscent }: RootState) => ({
  entity: directAscent.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(DirectAscentDetails);
